export const darkenHex = (hex: string, amount: number): string => {
    let col = hex.replace('#', '');
    if (col.length === 3) {
        col = col.split('').map(c => c + c).join('');
    }

    const num = parseInt(col, 16);
    let r = (num >> 16) - amount;
    let g = ((num >> 8) & 0x00FF) - amount;
    let b = (num & 0x0000FF) - amount;

    r = Math.max(0, r);
    g = Math.max(0, g);
    b = Math.max(0, b);

    return `#${[r, g, b]
        .map(x => x.toString(16).padStart(2, '0'))
        .join('')}`;
}
